import ContactInfo from '../BGH-RD3';

export default ContactInfo;
